import TotpGuard from '@/app/component/guard/totp'
import Layout from '@/app/component/layout/page'
import { PAGE } from '@/app/definitions'
import { AuthGuard, AuthHeader } from '@/app/module/auth'
import Notifications from '@/app/module/notifications'
import PhoneNumbers from '@/app/module/phonenumbers'
import { MatchProps } from '@/app/types'

type Props = {
  match: MatchProps
}

export default function PhoneNumbersPage({ match }: Props) {
  return (
    <AuthGuard url={match.url} path={match.path}>
      <Layout title="Phone Numbers - engageSPARK">
        <AuthHeader currentPage={PAGE.PHONENUMBERS.INDEX} />
        <TotpGuard>
          <PhoneNumbers />
        </TotpGuard>
      </Layout>
      <Notifications />
    </AuthGuard>
  )
}
